<script>
export default {
    name: "WhoDropdownHover"
}
</script>
<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 57.1 57.1" style="enable-background:new 0 0 57.1 57.1;" xml:space="preserve">
        <g>
	<g>
		<defs>
			<rect id="SVGID_1_" x="-8.4" y="22.5" width="78.5" height="39.8"/>
		</defs>
        <clipPath id="SVGID_2_">
			<use xlink:href="#SVGID_1_"  style="overflow:visible;"/>
		</clipPath>
        <g class="st0">
			<g id="Mask_Group_148" transform="translate(-1002 -1425)">
				<g id="Group_1526" transform="translate(1015 1436.766)">
					<g id="Ellipse_168">
						<circle class="st1-1" cx="15.5" cy="16.7" r="28.3"/>
                        <circle class="st2" cx="15.5" cy="16.7" r="27.8"/>
					</g>
                    <g id="Group_1525" transform="translate(3.373 14.319)">
						<g id="Polygon_24" transform="translate(48.915 41.343) rotate(180)">
							<path class="st1-1" d="M37.2,11.5l24.5,41.3h-49L37.2,11.5z"/>
                            <path class="st3" d="M37.2,13.5L14.5,51.9h45.4L37.2,13.5 M37.2,11.5l24.5,41.3h-49L37.2,11.5z"/>
						</g>
                        <path id="Path_1360" class="st2" d="M11.7,29v-40.5"/>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
        <g>
	<g>
		<defs>
			<polygon id="SVGID_3_" points="64.2,22.5 -5.3,22.5 -5.2,-2.8 64.3,-2.8 			"/>
		</defs>
        <clipPath id="SVGID_4_">
			<use xlink:href="#SVGID_3_"  style="overflow:visible;"/>
		</clipPath>
        <g class="st4">
			<g id="Mask_Group_148_1_" transform="translate(-1002 -1425)">
				<g id="Group_1526_1_" transform="translate(1015 1436.766)">
					<g id="Ellipse_168_1_">
						<circle class="st1-1" cx="15.5" cy="16.7" r="28.3"/>
                        <circle class="st5" cx="15.5" cy="16.7" r="27.8"/>
					</g>
                    <g id="Group_1525_1_" transform="translate(3.373 14.319)">
						<g id="Polygon_24_1_" transform="translate(48.915 41.343) rotate(180)">
							<path class="st1-1" d="M37.2,11.5l24.5,41.3h-49L37.2,11.5z"/>
                            <path class="st6" d="M61.2,52.9c0.1-0.1,0.1-0.2,0.2-0.3l-24.3-41L12.7,52.9H61.2z M59.9,51.9H14.5l22.7-38.4L59.9,51.9z"/>
						</g>
                        <path id="Path_1360_1_" class="st5" d="M11.7,29v-40.5"/>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>

</template>
<style lang="css" scoped>
.st0{clip-path:url(#SVGID_2_);}
.st1-1{fill:none;}
.st2{fill:none;stroke:#BEA064;}
.st3{fill:#BEA064;}
.st4{clip-path:url(#SVGID_4_);}
.st5{fill:none;stroke:#FFFFFF;}
.st6{fill:#FFFFFF;}
</style>
